import React, { useContext, useState } from 'react'
import { InitializeContext } from '../../../App';
import contactImg from '../../../assets/me/contact.jpg'
import contactImgBlur from '../../../assets/me/contact-blur.jpg'
import { BsArrowRight } from 'react-icons/bs';
import { BiLogoFacebook, BiLogoLinkedin } from 'react-icons/bi';
import { FiGithub } from 'react-icons/fi';
import toast from 'react-hot-toast';
import Swal from "sweetalert2";
import { SiBuymeacoffee } from 'react-icons/si';
import { BASE_API } from '../../../config';
import { PulseLoader } from 'react-spinners';

const Fade = require("react-reveal/Fade");

const initForm = {
  name: '',
  email: '',
  message: ''
}

export default function Contact() {
  const { theme } = useContext(InitializeContext);
  const [form, setForm] = useState(initForm);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loaded, setLoaded] = useState<boolean>(false);

  const handleChange = (e: any) => {
    setForm((oldForm) => ({
      ...oldForm,
      [e.target.name]: e.target.value
    }));
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    if (!form.name || !form.email || !form.message) {
      setIsLoading(false);
      return toast.error('Please fill up all the fields');
    } else if (form.name.length < 4) {
      setIsLoading(false);
      return toast.error('Type your full name please!');
    } else if (form.message.length < 20) {
      setIsLoading(false);
      return toast.error('Type more message please!');
    } else {
      fetch(`${BASE_API}/contact/sendEmail`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      })
        .then(res => res.json())
        .then(data => {
          if (data.message) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Your message has been sent successfully',
              showConfirmButton: false,
              timer: 2000
            });
          }
          setIsLoading(false);
          setForm(initForm);
        })
        .catch(err => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            showConfirmButton: false,
            timer: 2000
          });
        });
    }
  }

  return (
    <section id={'contact'} className={`w-full md:py-20 pb-0 md:pb-5 ${theme ? 'text-white bg-[#212428]' : 'bg-[#ECF0F3] text-black'}`}>
      <div className='text-center flex-col justify-center items-center md:flex'>
        <small className="text-sm mb-3">
          CONTACT.
        </small>
        <h1 className="font-bestWishes text-2xl md:text-3xl font-bold leading-tight">
          Connect With Me
        </h1>
      </div>
      <div className="hero">
        <div className="hero-content -mt-5">
          <Fade bottom distance="20px">
            <div className="flex flex-col justify-center lg:flex-row lg:gap-10 mb-10 w-full mt-5 mx-auto lg:shadow-md rounded-3xl">
              <div className='w-full lg:w-1/2'>
                <div className="outline-none md:px-4 pb-4 md:pt-4">
                  {
                    !loaded && (
                      <img
                        src={contactImgBlur}
                        className="rounded-3xl shadow-md border w-full"
                        alt="Toufiq Hasan Kiron"
                      />
                    )
                  }
                  <img
                    src={contactImg}
                    className="rounded-3xl shadow-md border w-full"
                    alt="Toufiq Hasan Kiron"
                    onLoad={() => {
                      setLoaded(true);
                    }
                    }
                    style={{ display: loaded ? 'block' : 'none' }}
                  />
                </div>
                <div className='md:px-4 pb-4'>
                  <h1 className='text-xl md:text-2xl font-bold'>Toufiq Hasan Kiron</h1>
                  <p className='pb-4 pt-1 font-semibold text-xs md:text-sm'>Full-stack Developer - Musician - Coffee Lover</p>
                  <p className='pb-4'>I am available for freelance work. Connect with me via email and call into my account.</p>
                  <p>Phone: <a href="https://api.whatsapp.com/send?phone=+8801855535091&text=Hello, I need help!" className={`font-semibold ${theme ? 'hover:text-warning' : 'hover:text-primary'}`}> +88 01855-535091</a> (Whatsapp)</p>
                  <p>Email: <a href="mailto:hello@toufiqhasankiron.com" className={`font-semibold ${theme ? 'hover:text-warning' : 'hover:text-primary'}`}>hello@toufiqhasankiron.com</a></p>
                  <div className='flex justify-start items-center gap-4 pt-4'>
                    <a href='https://www.facebook.com/toufiqhasankiron' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                      <BiLogoFacebook size={20} />
                    </a>
                    <a href='https://www.linkedin.com/in/toufiq-hasan-kiron' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                      <BiLogoLinkedin size={20} />
                    </a>
                    <a href='https://www.github.com/kiron0' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>
                      <FiGithub size={20} />
                    </a>
                    <a href='https://www.buymeacoffee.com/_thk' target='_blank' rel="noreferrer" className={`border cursor-pointer py-2 md:py-4 px-3 md:px-5 shadow-md rounded-xl group ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary bg-warning border-warning glass'} duration-500`}>
                      <SiBuymeacoffee size={20} className={`duration-500 ${theme ? 'group-hover:text-white' : 'text-black group-hover:text-white'}`} />
                    </a>
                  </div>
                </div>
              </div>
              <div className='w-full lg:w-2/3 rounded-3xl md:px-4 py-4'>
                <form onSubmit={handleSubmit} className='flex flex-col justify-center gap-5'>
                  <div className="form-control w-full">
                    <label className="label">
                      <span className="label-text">YOUR NAME</span>
                    </label>
                    <input type="text" className={`input input-bordered md:py-7 w-full ${theme ? 'focus:border-warning' : 'focus:border-primary'}`} name='name' value={form.name} onChange={handleChange} />
                  </div>
                  <div className="form-control w-full">
                    <label className="label">
                      <span className="label-text">YOUR EMAIL</span>
                    </label>
                    <input type="email" className={`input input-bordered md:py-7 w-full ${theme ? 'focus:border-warning' : 'focus:border-primary'}`} name='email' value={form.email} onChange={handleChange} />
                  </div>
                  <div className="form-control w-full">
                    <label className="label">
                      <span className="label-text">YOUR MESSAGE</span>
                    </label>
                    <textarea style={{ resize: 'none', height: '200px' }} typeof="text" className={`input input-bordered pt-3 w-full ${theme ? 'focus:border-warning' : 'focus:border-primary'}`} name='message' value={form.message} onChange={handleChange} />
                  </div>
                  <div>
                    {isLoading ? (
                      <button className={`border cursor-pointer py-2 md:py-3 px-3 md:px-5 shadow-md rounded-xl flex items-center gap-2 ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`} disabled>
                        Sending<PulseLoader color="#fff" size={6} />
                      </button>
                    ) : (
                      <button type='submit' className={`border cursor-pointer py-2 md:py-3 px-3 md:px-5 shadow-md rounded-xl flex items-center gap-2 ${theme ? 'hover:bg-warning hover:border-warning' : 'hover:bg-primary hover:border-primary glass'} hover:text-white duration-500`}>Send Message <BsArrowRight /></button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </section>
  )
}
